import { defineMessages } from 'react-intl';

export default defineMessages({
    password: {
        id: 'app.passwordForm.password',
        defaultMessage: 'New password'
    },
    repeatPassword: {
        id: 'app.passwordForm.repeatPassword',
        defaultMessage: 'Repeat new password'
    },
    submit: {
        id: 'app.passwordForm.submit',
        defaultMessage: 'Confirm and login'
    }
});
